import InvoicesTable from './InvoicesTable/InvoicesTable';
import PoliciesTable from './PoliciesTable/PoliciesTable';
import BillingSummary from './BillingSummary/BillingSummary';
import BillingSummaryPage from './BillingSummaryPage/BillingSummaryPage';
import MakePaymentPage from './MakePaymentPage/MakePaymentPage';
import BillingTable from './BillingTable/BilllingTable';

const billingComponentMap = {
    InvoicesTable: { component: 'InvoicesTable' },
    PoliciesTable: { component: 'PoliciesTable' },
    BillingSummary: { component: 'BillingSummary'},    
    BillingTable: { component: 'BillingTable' }

};

const billingAdditionalComponents = {
    InvoicesTable,
    PoliciesTable,
    BillingSummary,
    BillingTable
    
};

export {
    InvoicesTable,
    PoliciesTable,
    BillingSummary,
    BillingSummaryPage,
    MakePaymentPage,
    billingComponentMap,
    billingAdditionalComponents,
    BillingTable 
};
